import { ApiResult } from '@models/api';
import { useMutation, UseMutationOptions } from '@hooks/react-query';
import { fetcherMutation } from 'utils/react-query';

import { RegisterPrivyParams } from '../models/mutations';

function useRRegisterPrivy(
  options: UseMutationOptions<
    ApiResult<unknown>,
    Record<string, unknown>,
    RegisterPrivyParams
  > = {},
) {
  return useMutation<
    ApiResult<unknown>,
    Record<string, unknown>,
    RegisterPrivyParams
  >({
    mutationFn: async ({ context, variables }) =>
      await fetcherMutation({
        context: {
          ...context,
          method: 'POST',
          path: 'digisign/v1/register',
        },
        variables,
      }),
    ...options,
  });
}

export default useRRegisterPrivy;
